import Header from "../components/header";
import { useState } from "react";
import Onboarding from "../components/onboarding-module";

function OnboardingPage({serverStatus}){
    const [inputOpen,setInputOpen] = useState(false);
    const [onboardingState,SetOnboardingState] = useState(0);


    const handleClick = () => {
        console.log("Hi!");
        window.location.href="/feed";
    }

    const handleClick2 = () => {
        console.log("Hi!")
    }


    return <>
    <Header CTA='Skip onboarding' functionForButton={handleClick}></Header>
    <Onboarding></Onboarding>
    </>
}
    
export default OnboardingPage;